// 活动状态
const STATUS_VOTING = 1
const STATUS_VOTE_END = 2
const STATUS_RESULT_DISPLAY = 3
const STATUS_SUBMIT_MATERIAL = 4
const STATUS_ALTER_MATERIAL = 5

// 材料类型
const MEAL = 1
const HOTEL = 2
const STYLE = 3
const VIDEO_DYNAMIC = 4
const MERCHANT_VIDEO = 5

export const TITLE = {
  [STATUS_VOTING]: '2020婚礼纪犀选商家评选',
  [STATUS_VOTE_END]: '2020婚礼纪犀选商家评选',
  [STATUS_RESULT_DISPLAY]: '2020婚礼纪犀选商家评选',
  [STATUS_SUBMIT_MATERIAL]: '恭喜你，成功入围 婚礼纪年度商家评选',
  [STATUS_ALTER_MATERIAL]: '恭喜你，成功入围 婚礼纪年度商家评选'
}
export const DESC = {
  [STATUS_VOTING]: '微信扫一扫查看最新投票结果',
  [STATUS_VOTE_END]: '微信扫一扫查看投票结果',
  [STATUS_RESULT_DISPLAY]: '微信扫一扫查看获奖名单',
  [STATUS_SUBMIT_MATERIAL]:
    '请于 2021-01-07 00:00 前提交参评材料，否则将取消参评资格',
  [STATUS_ALTER_MATERIAL]: '2021-01-07 00:00 前可调整参评材料'
}
export const STATUS = {
  [STATUS_VOTING]: '投票火热进行中',
  [STATUS_VOTE_END]: '投票已结束',
  [STATUS_RESULT_DISPLAY]: '结果公示'
}
export const listApiMap = {
  [MEAL]: {
    url: '/p/wedding/index.php/Admin/APISetMeal/index',
    params: {
      with_pending: 1,
      commodity_type: 1,
      is_sold_out: 0,
      merchant_category_id: 0,
      status: 1
    }
  },
  [HOTEL]: {
    url: '/p/wedding/index.php/admin/APIHotelMerchant/hall_list',
    params: {
      status: 1,
      is_published: 1
    }
  },
  [STYLE]: {
    url: '/hms/hljLocalserviceProduct/adminApi/setMeal/style/list',
    params: {
      categoryId: 0,
      isPublish: 1
    }
  },
  [VIDEO_DYNAMIC]: {
    url: '/p/wedding/index.php/home/APINote/my_notes',
    params: {
      note_type: 1,
      status: 1
    }
  },
  [MERCHANT_VIDEO]: {
    url: '/p/wedding/Admin/APIMerchantVideo/list',
    params: {
      status: 2
    }
  }
}

export const materialPropertyMap = {
  [MEAL]: [6, 7, 9, 14],
  [HOTEL]: [13],
  [STYLE]: [12],
  [VIDEO_DYNAMIC]: [8, 11],
  [MERCHANT_VIDEO]: [2]
}
export const materialName = {
  [MEAL]: '案例',
  [HOTEL]: '宴会厅',
  [STYLE]: '款式',
  [VIDEO_DYNAMIC]: '视频动态',
  [MERCHANT_VIDEO]: '店铺视频'
}
export const materialCount = {
  [MEAL]: 3,
  [HOTEL]: 3,
  [STYLE]: 3,
  [VIDEO_DYNAMIC]: 1,
  [MERCHANT_VIDEO]: 1
}
export const pageSizeKey = {
  [MEAL]: 'per_page',
  [HOTEL]: 'per_page',
  [STYLE]: 'perPage',
  [VIDEO_DYNAMIC]: 'perPage',
  [MERCHANT_VIDEO]: 'per_page'
}
